
jQuery(document).ready(function ($) {
    'use strict';

    var HH = window.HH || {};

    if (typeof gsap === 'undefined' || typeof HH.revelerEnLignes !== 'function') {
        return;
    }

    /* Moins de mouvement demande : on ne pose aucun etat de depart, donc
       la page reste telle que le navigateur l'a rendue. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    var hdp = document.querySelector('.bloc_hdp');
    var texte = hdp ? hdp.querySelector('.texte') : null;

    /**
     * CHRONOLOGIE
     * Positions de depart sur la timeline et durees, en secondes. Les
     * chevauchements sont voulus : joues bout a bout, ces mouvements
     * donneraient un premier ecran qui traine.
     */
    var DEPART_TRIANGLE_1 = 0;
    var DEPART_TRIANGLE_2 = 0.25;
    var DEPART_SURTITRE = 0.35;
    var DEPART_TITRE = 0.45;
    var DEPART_ACCROCHE = 0.7;
    var DEPART_BOUTON = 0.85;

    var DUREE_TRIANGLE = 0.8;
    var LIGNES = {duree: 0.7, decalage: 0.09};
    var DUREE_FONDU = 0.5;

    /**
     * Un triangle n'est animable que s'il est reellement visible.
     * header.scss ne les habille que sous #header.bg_image, les masque
     * sous small-screen et sur les fiches catalogue : partout ailleurs ce
     * sont des div nues, larges mais sans fond ni decoupe. La couleur de
     * fond calculee fait donc partie de la mesure, sans quoi la seule
     * largeur les accepterait a tort.
     */
    function triangleVisible(selecteur) {
        var element = document.querySelector('#header ' + selecteur);

        if (!element || element.getBoundingClientRect().width <= 0) {
            return null;
        }

        var fond = getComputedStyle(element).backgroundColor;

        if (!fond || fond === 'transparent' || fond === 'rgba(0, 0, 0, 0)') {
            return null;
        }

        return element;
    }

    var elements = {
        triangle_1: triangleVisible('.triangle_1'),
        triangle_2: triangleVisible('.triangle_2'),
        surtitre: texte ? texte.querySelector('.surtitre') : null,
        titre: texte ? texte.querySelector('h1') : null,
        accroche: texte ? texte.querySelector('.accroche') : null,
        bouton: texte ? texte.querySelector('.bouton') : null
    };

    /* Rien a animer sur cette page : haut de page sans image donc sans
       triangles, et pas de bloc texte. */
    if (!elements.triangle_1 && !elements.triangle_2 && !texte) {
        return;
    }

    /**
     * Etats de depart, poses immediatement et non apres l'attente des
     * polices : differer ce masquage laisserait le contenu s'afficher
     * puis disparaitre.
     *
     * L'angle droit de chaque triangle est le coin qui l'ancre : le
     * clip-path du noir place le sien en haut a droite, celui du magenta
     * en bas a droite. Chacun se deplie donc depuis sa propre pointe.
     */
    function poserEtatsDeDepart() {
        /* global.scss pose transition: all 150ms sur tous les <a>, bouton
           compris, qui interpolerait par dessus chaque frame de GSAP.
           Coupee avant le premier gsap.set : dans l'autre ordre, le
           passage a opacity 0 declenche lui-meme un fondu sortant. */
        if (elements.bouton) {
            elements.bouton.style.transition = 'none';
        }

        if (elements.triangle_1) {
            gsap.set(elements.triangle_1, {scale: 0, transformOrigin: 'top right'});
        }

        if (elements.triangle_2) {
            gsap.set(elements.triangle_2, {scale: 0, transformOrigin: 'bottom right'});
        }

        ['surtitre', 'titre', 'accroche', 'bouton'].forEach(function (nom) {
            if (elements[nom]) {
                gsap.set(elements[nom], {opacity: 0});
            }
        });
    }

    function rendreLaTransition() {
        if (elements.bouton) {
            elements.bouton.style.transition = '';
        }
    }

    function deplierTriangle(tl, element, position) {
        if (!element) {
            return;
        }

        tl.to(element, {
            scale: 1,
            duration: DUREE_TRIANGLE
        }, position);
    }

    function fondu(tl, element, position) {
        if (!element) {
            return;
        }

        tl.to(element, {
            opacity: 1,
            duration: DUREE_FONDU
        }, position);
    }

    poserEtatsDeDepart();

    HH.policesPretes().then(function () {
        var tl = gsap.timeline({onComplete: rendreLaTransition});

        deplierTriangle(tl, elements.triangle_1, DEPART_TRIANGLE_1);
        deplierTriangle(tl, elements.triangle_2, DEPART_TRIANGLE_2);

        HH.revelerEnLignes(tl, elements.surtitre, DEPART_SURTITRE, LIGNES);
        HH.revelerEnLignes(tl, elements.titre, DEPART_TITRE, LIGNES);
        fondu(tl, elements.accroche, DEPART_ACCROCHE);
        fondu(tl, elements.bouton, DEPART_BOUTON);
    });
});
